import { render, staticRenderFns } from "./ComboParam.vue?vue&type=template&id=2fdd3f63"
import script from "./ComboParam.vue?vue&type=script&lang=js"
export * from "./ComboParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports